module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.page', {
            url: '/page/:scheduleKey',
        })
        .state('shop.embedded', {
            // this state is used for dynamic content pages which are embedded as iframes
            // in woolworths mobile applications
            url: '/embedded/:scheduleKey',
            views: {
                '@': {
                    template: '<div style="height: 100%;" wow-hide-scroll wow-scrollbar><oly-dynamic-content oly-dc-url-schedule></oly-dynamic-content></div>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/page.js